import {handleLogout} from "../redux/authentication"
import {store} from "@src/redux/store"
import useJwt from '@src/auth/jwt/useJwt'

export const logout = () => {
    return useJwt.logout()
}

export const logoutIfRefreshTokenNotValid = () => {
    const item = window.localStorage.getItem('userData')
    const userData = item ? JSON.parse(item) : {}
    const refreshTokenExpiration = userData?.refreshTokenExpiration
    const date = new Date()
    if (refreshTokenExpiration && refreshTokenExpiration < (date.getTime() / 1000)) {
        store.dispatch(handleLogout())
        logout()
    }
}